<template>
  <div>
    <b-loading :active="isLoading" :is-full-page="true" animation=""></b-loading>
    <div style="padding: 0 10px">
      <br>
      <h1 class="align-left is-size-3 has-text-weight-bold">{{ $t('MyPlan') }}</h1>
      <p class="align-left">{{ $store.state.userInfo.msisdn }}</p>
      <br>
            <div style="background: rgba(0, 0, 0, 0.2); border-radius: 5px; font-size: 0.9em; padding: 10px;">
              {{ $t('PromoMsg2') }}
            </div>
<!--      <div v-if="!$store.state.userInfo.tenureRestricted"-->
<!--           style="background: rgba(0, 0, 0, 0.2); border-radius: 5px; font-size: 1em; padding: 10px;">-->
<!--        {{ $t('Prepaid2020Msg') }}-->
<!--        <br>-->
<!--        <br>-->
<!--        {{ $t('StartNow') }}-->
<!--      </div>-->

      <div style="display: flex; text-align: center">
        <a @click="selectTab('activePlan')" class="tab-btn"
           :class="{'tab-btn-active': selectedTab === 'activePlan'}">
          <img style="width: 30px; margin-bottom: 10px" src="../assets/active-plan.png"
               alt="customize plan">
          <div class="is-block">{{ $t('ActivePlan') }}</div>
        </a>
        <a @click="selectTab('futurePlan')" v-if="$store.state.userInfo.hasFlexiOffer" class="tab-btn"
           :class="{'tab-btn-active': selectedTab === 'futurePlan'}">
          <img style="width: 30px; margin-bottom: 10px" src="../assets/future-plan.png"
               alt="customize plan">
          <div class="is-block">{{ $t('FuturePlan') }}</div>
        </a>
      </div>

      <transition name="fade" mode="out-in">
        <div :key="1" v-if="selectedTab === 'activePlan'" class="zain-card">
          <div v-if="$store.state.userInfo.currentOfferCode !== null" class="has-text-black">

            <div
                v-if="$store.state.userInfo.currentOfferEndsAfterDays && $store.state.userInfo.currentOfferEndsAfterDays < 100">
              <small class="has-text-black">{{ $t('PlanExpireIn') }}
                <span dir="ltr" style="color: #4c9928; font-weight: bold; font-size: 1.1em">
                  {{ $store.state.userInfo.currentOfferEndDatePretty }}
                </span>
              </small>
              <hr>
            </div>

            <div class="plan-benefits-grid">
              <div v-for="(benefit, i) in $store.state.userInfo.currentOfferBenefits.filter(x => parseInt(x.value))"
                   class="grid-benefit" :key="i">
                <h2 v-if="benefit.type === '5G'">{{ $t('Active') }}</h2>
                <h2 v-else>
                  {{
                    benefit.isUnlimited ? $t('Unlimited') : benefit.value.replace('.0', '') + ' ' + $tif(benefit.unitEn, benefit.unitAr)
                  }}
                </h2>
                <p>{{ $tif(benefit.titleEn, benefit.titleAr) }}</p>
              </div>
              <div v-for="(benefit, i) in $store.state.userInfo.upsellBenefits"
                   class="grid-benefit" :key="benefit.State+i">
                <h2>{{ $t('Extra') }}</h2>
                <p>{{ $store.state.upsellOffers[benefit.Name][$store.state.language] }}</p>
              </div>
            </div>
            <hr>
            <div class="columns is-mobile">
              <div class="column align-left is-5" style="padding: 20px">
                <h2>KD {{ $store.state.userInfo.currentOfferPrice }}</h2>
                <p>{{ $t('PlanPrice') }}</p>
              </div>
              <div class="column align-right">
                <b-switch class="float-right is-rounded" style="margin-top: 13px" size="is-medium"
                          :value="this.$store.state.userInfo.currentOfferAutoRenew" v-model="autoRenew"
                          type="is-success" @input="toggleAutoRenew"></b-switch>
                <br/><br/>
                <small>{{ $t('AutoRenewIs') }} {{ autoRenew ? $t('Enabled') : $t('Disabled') }}</small>&nbsp;
                <i class="fa fa-circle" style="font-size: 0.8em" :style="autoRenew? 'color: #7bc440': 'color: darkgray'" />&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div v-else>
            <img src="../assets/triangle-alert.png" alt="No Plan Currently" style="width: 50px;">
            <br/><br/>
            <p class="has-text-black">{{ $t('YouHaveNoPlanMsg') }}</p>
          </div>

          <b-button @click="changePlan()" style="margin-top: 20px" class="pink-btn">
            {{ $store.state.userInfo.currentOfferCode ? $t('ChangeMyPlan') :  $t('CreateMyPlan') }}
          </b-button>
        </div>
        <div :key="2" v-else-if="selectedTab === 'futurePlan'" class="zain-card">
          <div v-if="$store.state.userInfo.currentOfferAutoRenew">
            <div
                v-if="$store.state.userInfo.currentOfferEndsAfterDays && $store.state.userInfo.currentOfferEndsAfterDays < 100">
              <small class="has-text-black">{{ $t('FuturePlanMsg') }}
                <span style="color: #4c9928; font-weight: bold; font-size: 1.1em">
                  {{ $store.state.userInfo.currentOfferEndsAfterDays }} {{ $t('days') }}
                </span>
              </small>
              <hr>
            </div>
            <div class="plan-benefits-grid">
              <div v-for="(benefit, i) in $store.state.userInfo.futureOrderBenefits.filter(x => parseInt(x.value))"
                   class="grid-benefit"
                   :key="i">
                <h2 v-if="benefit.type === '5G'">{{ $t('Active') }}</h2>
                <h2 v-else>
                  {{
                    benefit.isUnlimited ? $t('Unlimited') : benefit.value.replace('.0', '') + ' ' +
                        $tif(benefit.unitEn, benefit.unitAr)
                  }}
                </h2>
                <p>{{ $tif(benefit.titleEn, benefit.titleAr) }}</p>
              </div>
              <template v-if="$store.state.userInfo.currentAndFutureMatch">
                <div v-for="(benefit, i) in $store.state.userInfo.upsellBenefits"
                     class="grid-benefit" :key="benefit.State+i">
                  <h2>{{ $t('Extra') }}</h2>
                  <p>{{ $store.state.upsellOffers[benefit.Name][$store.state.language] }}</p>
                </div>
              </template>
            </div>
            <hr>
            <div class="align-left" style="padding: 20px">
              <h2>KD {{ $store.state.userInfo.futureOrderPrice }}</h2>
              <p>{{ $t('PlanPrice') }}</p>
            </div>
            <b-button @click="changePlan()" style="margin-top: 20px" class="pink-btn">
              {{ $t('ChangeFuturePlan') }}
            </b-button>
          </div>
          <div v-else>
            <img src="../assets/triangle-alert.png" alt="No Future Order" style="width: 50px;">
            <br/><br/>
            <p class="has-text-black">{{ $t('NoFutureOrderMsg') }}</p>
            <b-button @click="setFuturePlan()" style="margin-top: 20px" class="pink-btn">
              {{ $t('SetFuturePlan') }}
            </b-button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import BLoading from "buefy/src/components/loading/Loading"
import BSwitch from "buefy/src/components/switch/Switch"
import BButton from "buefy/src/components/button/Button"

// noinspection ES6ShorthandObjectProperty
export default {
  name: "MyPlan",
  components: {
    BButton,
    BSwitch,
    BLoading
  },
  data: () => {
    return {
      step: 1,
      selectedTab: 'activePlan',
      isLoading: false,
      autoRenew: false
    }
  },
  computed: {},
  methods: {
    changePlan() {
      // tenure check

      // if (this.$store.state.userInfo.tenureCompletion.day) {
      //   this.$buefy.dialog.alert({
      //     message: `${ this.$t('LowTenure1') } <b>${ this.$store.state.userInfo.tenureCompletion.day } ${ this.$t(this.$store.state.userInfo.tenureCompletion.month) } ${ this.$store.state.userInfo.tenureCompletion.year }</b>
      //       <br>
      //       <br>
      //       ${ this.$t('LowTenure2') }
      //       <br>
      //       <br>
      //       <a href="${ this.$t('LowTenure3') }" target="_blank" style="text-decoration: underline">${ this.$t('LowTenure3') }</a>
      //       <br>
      //     <br>`,
      //     confirmText: this.$t('Back')
      //   })
      //
      //   return
      // }


      this.$store.state.settingFuture = this.selectedTab === 'futurePlan'
      this.$router.push('/plan')
    },
    setFuturePlan() {
      this.$buefy.dialog.confirm({
        message: this.$t('FutureAutoRenewMsg'),
        confirmText: this.$t('OK'),
        cancelText: this.$t('Cancel'),
        onConfirm: async () => {
          this.setAutoRenew(true)
        }
      })
    },
    selectTab(selectedTab) {
      this.selectedTab = selectedTab
    },
    toggleAutoRenew(isAutoRenewOn) {
      this.$buefy.dialog.confirm({
        confirmText: this.$t('OK'),
        cancelText: this.$t('Cancel'),
        message: isAutoRenewOn ?
            this.$t('AutoRenewConfirm') :
            `<b class="has-text-black">${ this.$t('AutoRenewOffMsg') }</b>` +
            (this.$store.state.userInfo.hasFlexiOffer ? `<br><br>${ this.$t('AutoRenewOffFlexiMsg') }` : ''),
        onConfirm: async () => {
          this.setAutoRenew(isAutoRenewOn)
          this.$ga.event('AutoRenew', isAutoRenewOn ? 'Confirm-On' : 'Confirm-Off')

        },
        onCancel: () => {
          this.autoRenew = !isAutoRenewOn
          this.$ga.event('AutoRenew', isAutoRenewOn ? 'Cancel-On' : 'Cancel-Off')
        }
      })
      this.$ga.event('AutoRenew', isAutoRenewOn ? 'On' : 'Off')
    },
    async setAutoRenew(isAutoRenewOn) {
      this.isLoading = true
      let res = await this.$store.dispatch('setAutoRenew', {
        serviceCode: this.$store.state.userInfo.currentOfferCode,
        isAutoRenewOn: isAutoRenewOn
      })

      this.isLoading = false

      if (res.data && res.data.isSuccess) {
        this.$buefy.dialog.alert({
          confirmText: this.$t('Back'),
          type: 'is-success',
          message: isAutoRenewOn ? this.$t('AutoRenewSuccessOn') : this.$t('AutoRenewSuccessOff')
        })
        await this.refreshData()
      } else {
        this.autoRenew = !isAutoRenewOn
        this.$buefy.dialog.alert({
          confirmText: this.$t('Back'),
          type: 'is-danger',
          message: this.$t('AutoRenewError')
        })
      }
      this.$ga.event('AutoRenew', `Result-${ (isAutoRenewOn ? 'On' : 'Off') }-${ (res.data.isSuccess ? 'Success' : 'Failure') }`)
    },
    async refreshData() {
      this.isLoading = true
      await this.$store.dispatch('getPossibleSettings')
      await this.$store.dispatch('getUserInfo')
      this.isLoading = false
      this.$store.state.isDirty = false
      this.autoRenew = this.$store.state.userInfo.currentOfferAutoRenew
    }
  },
  async mounted() {
    if (this.$store.state.isDirty)
      await this.refreshData()
    this.autoRenew = this.$store.state.userInfo.currentOfferAutoRenew
    //
    // this.$buefy.dialog.alert({
    //   message: this.$t('Prepaid2020Msg'),
    //   confirmText: this.$t('StartNow')
    // })
  },
  watch: {}
}

</script>

<style lang="scss" scoped>

.zain-card {
  background: white;
  color: black;
  border-radius: 5px;
  padding: 20px;
}

.zain-card h2 {
  color: #48146a;
  font-weight: bold;
  font-size: 1.2rem;
}

.zain-card p, .zain-card small {
  color: black;
  font-size: 0.75rem;
}

[dir='rtl'] .zain-card p, [dir='rtl'] .zain-card small {
  font-size: 0.95rem;
}

* {
  color: white;
}

.selected-option {
  background: rgba(238, 238, 238, 0.27);
}

.plan-benefits-grid {

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 30px
}

.grid-benefit:last-child:nth-last-child(odd) {
  grid-column: auto / span 2;
}

.grid-benefit:first-child:nth-last-child(even) ~ .grid-benefit {
  grid-column: auto / span 1;
}

</style>
